<template>
  <div class="ignore-period-renderer">
    <span class="ignore-period-renderer__text">{{ params.value || '' }}</span>
    <span
      v-if="isEditable"
      class="ignore-period-renderer__icon"
      @mousedown.stop
      @click.stop="openPicker"
    >
      <v-icon x-small>mdi-calendar-range</v-icon>
    </span>
  </div>
</template>

<script>
import Vue from 'vue';
import { get } from 'lodash';

export default Vue.extend({
  name: 'IgnorePeriodCellRenderer',

  computed: {
    isEditable() {
      const { tsgKey, competitorKey } = this.params;
      return !!get(
        this.params,
        `data.toolStoreGroups.${tsgKey}.competitor.feed.${competitorKey}.competitorKey`
      );
    },
  },

  methods: {
    openPicker() {
      this.params.api.startEditingCell({
        rowIndex: this.params.rowIndex,
        colKey: this.params.column.getColId(),
      });
    },
  },
});
</script>

<style scoped>
.ignore-period-renderer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 4px;
}

.ignore-period-renderer__text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ignore-period-renderer__icon {
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
</style>
